import React from "react";
import { Box } from "@mui/material";
import colors from "../../../../theme/colors";
import "./GlobalCommunity.css";
import GlobalCommunityAnimation from "../animations/globalCommunityAnimation";
import GlobalCommunityUI from "./GlobalCommunityUI";

const GlobalCommunity = () => {
  return (
    <Box component="section" className="global-community-section" sx={{ backgroundColor: colors.home.navyDeep }}>
      <GlobalCommunityAnimation>
        <GlobalCommunityUI />
      </GlobalCommunityAnimation>
    </Box>
  );
};

export default GlobalCommunity;